module.exports = __webpack_public_path__ + "img/ds.1b155cd7.jpg";